var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CafeLayout',{staticClass:"cafePage"},[_c('div',[_c('p',{staticClass:"city-time"},[_c('span',[_vm._v("toronto")]),_vm._v("—"),_c('span',{attrs:{"id":"toronto-time"}},[_vm._v("time")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }